import { render, staticRenderFns } from "./action-table-item.vue?vue&type=template&id=8cbfb8ca&scoped=true"
import script from "./action-table-item.vue?vue&type=script&lang=js"
export * from "./action-table-item.vue?vue&type=script&lang=js"
import style0 from "./action-table-item.vue?vue&type=style&index=0&id=8cbfb8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbfb8ca",
  null
  
)

export default component.exports